import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { v4 as uuid } from "uuid";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import InputAdornment from "@material-ui/core/InputAdornment";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import Button2 from "@material-ui/core/Button";
import SVG from "react-inlinesvg";
import Input from "@material-ui/core/Input";

import Preview from "../components/Preview.js";
import { BiCopy } from "react-icons/bi";

const initialValues = {
  nameAz: "",
  nameEn: "",
  nameRu: "",
  photo: ""
};

export default function Create(props) {
  const {
    show,
    onHide,
    onCategoryNames,
    skip,
    take,
    sortField,
    orderBy,
    onOrders,
    orders
  } = props;

  const [imageSrc, setImageSrc] = useState("");
  const [preview, setPreview] = useState(false);
  const [file, setFile] = useState("");
  const form = useRef(null);


  const [isError, setIsError] = useState("");
  const CreateSchema = Yup.object().shape({
    nameAz: Yup.string().required("Name Az is required"),
    nameEn: Yup.string().required("Name En is required"),
    nameRu: Yup.string().required("Name Ru is required"),
  });

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };



  const imagePreview = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    setFile(e.target.value);

    reader.onloadend = () => {
      setImageSrc(reader.result);
    };

    reader.readAsDataURL(file);

    setPreview(true);
  };

  const onClick = (e) => {
    setPreview(false);
    setImageSrc("");
    setFile("");
  };


  const onPostCategoryName = (values, resetForm, setSubmitting) => {

    const categoryName = new FormData(form.current);

    axios
      .post(`${process.env.REACT_APP_API_URL}campaign/category`, categoryName, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onCategoryNames(skip, take, sortField, orderBy);
        onOrders(orders)
        setPreview(false);
        setImageSrc("");
        setFile("");
        setSubmitting(false);
        resetForm();
        onHide();
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostCategoryName(values, resetForm, setSubmitting);
    },
  });

  const handleCopyName = (name) => {
    const nameAz = formik.values.nameAz;
    formik.setFieldValue(name, nameAz);
  };

  useEffect(() => {
    setIsError("");
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="edit"
      centered
      className="modal-right pr-0"
    >
      <form onSubmit={formik.handleSubmit} ref={form}>
        <Modal.Header closeButton> 
          <Modal.Title id="edit">Create</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="nameAz"
                    label="Name Az"
                    placeholder="Name Az"
                    className="w-100"
                    error={getInputClasses("nameAz")}
                    {...formik.getFieldProps("nameAz")}
                  />
                </div>
                {formik.touched.nameAz && formik.errors.nameAz ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.nameAz}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="nameEn"
                    label="Name En"
                    placeholder="Name En"
                    className="w-100"
                    title="Copy from Name az"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ cursor: "pointer" }}
                        >
                          <BiCopy
                            onClick={() => handleCopyName("nameEn")}
                            style={{ width: "17px", height: "17px", color: "grey" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    error={getInputClasses("nameEn")}
                    {...formik.getFieldProps("nameEn")}
                  />
                </div>
                {formik.touched.nameEn && formik.errors.nameEn ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.nameEn}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="nameRu"
                    label="Name Ru"
                    placeholder="Name Ru"
                    className="w-100"
                    title="Copy from Name az"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ cursor: "pointer" }}
                        >
                          <BiCopy
                            onClick={() => handleCopyName("nameRu")}
                            style={{ width: "17px", height: "17px", color: "grey" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    error={getInputClasses("nameRu")}
                    {...formik.getFieldProps("nameRu")}
                  />
                </div>
                {formik.touched.nameRu && formik.errors.nameRu ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.nameRu}</div>
                  </div>
                ) : null}

              </div>


              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3">
                  <label htmlFor="contained-button-file">
                    <Input
                      accept="image/*"
                      id="contained-button-file"
                      type="file"
                      name="photo"
                      label="File {Path}"
                      placeholder="File Path"
                      className="w-100"
                      onChange={imagePreview}
                      value={file}
                      hidden
                    />
                    <Button2 variant="contained" component="span">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Devices/Camera.svg"
                        )}
                        className="mr-2"
                      />
                      Upload image
                    </Button2>
                  </label>
                  <Preview
                    preview={preview}
                    imageSrc={imageSrc}
                    onClick={onClick}
                  />
                </div>
                {formik.touched.photo && formik.errors.photo ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.photo}
                    </div>
                  </div>
                ) : null}

                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => onHide(false)}>
            Close
          </Button>
          <Button type="submit">Create</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
